import { SessionData } from '../../services/embedService';

export type PaymentMethodTab = 'wallet' | 'card';

export function displayTokenSymbol(cryptoCurrency: string): string {
  const raw = cryptoCurrency.trim().toUpperCase();
  if (raw.includes('USDC') || raw.includes('USDT')) return 'USDC';
  const token = raw.split('_')[0];
  return token || 'USDC';
}

export function displayNetwork(cryptoCurrency: string): string {
  const raw = cryptoCurrency.trim().toLowerCase();
  if (raw.includes('polygon')) return 'Polygon';
  if (raw.includes('ethereum') || raw === 'eth') return 'Ethereum';
  const parts = raw.split('_').slice(1);
  if (parts.length === 0) return 'Polygon';
  return parts.join(' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatPlainAmount(amount: number, maxDecimals = 2): string {
  return amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: maxDecimals });
}

export function openCheckoutUrl(url: string) {
  const opened = window.open(url, '_blank', 'noopener,noreferrer');
  if (!opened) window.location.assign(url);
}

export function deriveCheckoutAmounts(session: SessionData) {
  const fiatCode = session.fiatCurrency.trim().toUpperCase() || 'USD';
  const fiatAmount = session.fiatAmount > 0 ? session.fiatAmount : 0;
  const youGet =
    session.cryptoAmount != null && session.cryptoAmount > 0
      ? session.cryptoAmount
      : Math.round((fiatAmount / 1.026) * 100) / 100;
  const yourSpend = Math.round(fiatAmount * 1.0433 * 100) / 100;
  const usdPerToken = youGet > 0 ? Math.round((yourSpend / youGet) * 100) / 100 : 1.09;

  return { fiatCode, fiatAmount, youGet, yourSpend, usdPerToken };
}
